import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['radio', 'conditionalBlock', 'details', 'duration'];

  connect() {
    this.refresh();
  }

  refresh() {
    const selected = this.radioTargets.find((radio) => radio.checked);

    if (selected && selected.value === 'true') {
      this.conditionalBlockTarget.classList.remove('d-none');
    } else {
      this.conditionalBlockTarget.classList.add('d-none');
      this.detailsTarget.value = '';
      this.durationTarget.value = '';
    }
  }
}
